export default __webpack_public_path__ + "static/media/Data Security.9c8e886d.png";